import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ForeCastService {

  constructor(private api: ApiService) { }

  getAllForecast(data:any): Observable<any> {
    return this.api.post(environment.getAllForecast,data);
  }

  createForecast(data:any): Observable<any> {
    return this.api.post(environment.createForecast,data);
  }

  updateForecast(data:any): Observable<any> {
    return this.api.post(environment.updateForecast,data);
  }

  getforecastAnalytics(data:any): Observable<any> {
    return this.api.post(environment.getforecastAnalytics,data);
  }

  deleteForecast(data:any): Observable<any> {
    return this.api.post(environment.deleteForecast,data);
  }

  getAllDealByUser(data:any): Observable<any> {
    return this.api.post(environment.getAllDealByUser,data);
  }
}


